<template>

  <v-navigation-drawer
    :class="barOpen ? 'back elevation-0 pa-2' : 'back'"
    v-model="barOpen"
    light
    hide-overlay
    temporary
    right
    floating
    absolute
    :width="barOpen ? 800 : 0"
    disable-resize-watcher
    stateless
  >

    <v-treeview
      v-if="template"
      disable-resize-watcher="true"
      style="cursor: pointer"
      :items="getTree"
      :active.sync="node.active"
      :open.sync="node.opened"
      :load-children="loadChildren"
      loading-icon="highlight_off"
      active-class="secondary lighten-5"
      class="caption font-weight-medium font-condensend"
      item-disabled="disabled"
      activatable
      item-key="$id"
      return-object
    >
      <template v-slot:label="{ item, open, active}">

        <v-layout v-if="checkBusy(item)" align-center>
          <span class="caption font-weight-medium font-condensend" :class="checkType(item) ? 'blacktext--text' : 'blacktext--text'">{{item.name}}</span>
          <v-btn :data-testid="$options.name + 'v-btn' + 'busy'" disabled small color="secondaty" @click.stop="">
            <span class="caption font-weight-medium font-condensend blacktext--text">{{$t('busy')}}</span>
          </v-btn>
        </v-layout>

        <span v-if="!checkBusy(item)" class="caption font-weight-medium font-condensend" :class="checkType(item) ? 'green--text' : 'blacktext--text'">{{item.name}}</span>
        <v-btn :data-testid="$options.name + 'v-btn' + 'onItemSelect-item'" v-if="active && checkType(item) && !checkBusy(item)" small color="primary" @click.stop="() => onItemSelect(item)">
          <span class="caption font-weight-medium font-condensend">{{$t('choose')}}</span>
        </v-btn>
        
      </template>

      <template v-slot:prepend="{ item, open, active }">

          <svg-icon            
            :color="$getColor($store.state.monitoring.status[item.$id])"
            :name="$checkItem(item)"
            width="20"
          />

      </template>

    </v-treeview>

  </v-navigation-drawer>

</template>

<script lang="ts">
import Vue from 'vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { CCMDBObject } from '@entcor/ebridge'

// Типы
interface TreeNode {
  $id?: string
  id?: string
  cls?: string
  name?: string
  port_type?: string
  children?: TreeNode[]
  brefs?: Array<{ cls?: string; [key: string]: any }>
  [key: string]: any
}

interface TemplateItem {
  id?: string
  port_type?: string
  [key: string]: any
}

interface NodeState {
  active: any[]
  opened: any[]
}

interface ComponentData {
  barOpen: boolean
  tree: TreeNode[]
  node: NodeState
}

interface StatusColor {
  back_color?: string
  name?: string
}

export default Vue.extend({
  name: 'ENDPOINS_TREE',

  components: {
    'svg-icon': svgIcon,
  },

  props: {
    open: {
      type: Boolean,
      default: () => false
    },
    templates: {
      type: Array as () => TemplateItem[],
      default: () => []
    },
    template: {
      type: String,
      default: () => null
    },
    portType: {
      type: String,
      default: () => null
    },
    customTree: {
      type: Array as () => TreeNode[],
      default: () => []
    },
  },

  data(): ComponentData {
    return {
      barOpen: false,
      tree: [],
      node: {
        active: [],
        opened: []
      }
    }
  },

  computed: {
    getTree(): TreeNode[] {
      return this.customTree.length ? this.customTree : this.tree
    },
  },

  watch: {
    open: {
      handler(newVal: boolean): void {
        this.barOpen = !this.barOpen
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      if (this.open) {
        this.barOpen = true
      }
      console.log('ENDPOINS_TREE', 'template', this.template)
      this.loadTree()
    },

    async loadTree(item?: TreeNode): Promise<void> {
      try {
        const query = {
          id: ['/physical'],
          notNull: true,
          data: {
            namePath: true,
            children: {
              data: {
                brefs: true,
                children: true,
                filter: {
                  or: [
                    { cls: 'location' },
                    { cls: 'cabinet' },
                    { cls: 'device' },
                    { cls: 'slot' },
                    { cls: 'module' },
                    { cls: 'port' },
                    { cls: 'socket' }
                  ]
                }
              },
              filter: {
                or: [
                  { cls: 'location' },
                  { cls: 'cabinet' },
                  { cls: 'device' }
                ]
              }
            },
          }
        }
        
        const obj = await this.$bridge.cmdbQuery(query)

        if (obj) {
          const cycle = (arr: TreeNode[]): TreeNode[] => {
            arr.forEach(item => {
              if (item.children) {
                if (item.cls === 'port') {
                  delete item.children
                } else if (item.children.length) {
                  item.children = []
                } else {
                  delete item.children
                }
              }
            })
            return arr
          }
          const children = cycle(obj[0].children)
          this.tree = children
        } else {
          console.log('LOGICAL_TREE', 'loadTree', 'smth wrong')
        }
      } catch (err) {
        console.error('CATCH', 'LOGICAL_TREE', 'loadTree', err)
      }
    },

    async loadChildren(data$: TreeNode): Promise<TreeNode | undefined> {
      try {
        const query = {
          id: [data$.$id],
          notNull: true,
          data: {
            namePath: true,
            children: {
              data: {
                brefs: true,
                children: true,
                filter: {
                  or: [
                    { cls: 'location' },
                    { cls: 'cabinet' },
                    { cls: 'device' },
                    { cls: 'slot' },
                    { cls: 'module' },
                    { cls: 'port' },
                    { cls: 'socket' }
                  ]
                }
              },
              filter: {
                or: [
                  { cls: 'location' },
                  { cls: 'cabinet' },
                  { cls: 'device' },
                  { cls: 'slot' },
                  { cls: 'module' },
                  { cls: 'port' },
                  { cls: 'socket' }
                ]
              }
            },
          }
        }

        const co = await this.$bridge.cmdbQuery(query)
        if (co) {
          const cycle = (arr: TreeNode[]): TreeNode[] => {
            arr.forEach(item => {
              if (item.children) {
                if (item.cls === 'port') {
                  delete item.children
                } else if (item.children.length) {
                  item.children = []
                } else {
                  delete item.children
                }
              }
            })
            return arr
          }
          const children = cycle(co[0].children)
          console.log('LOGICAL_TREE', 'loadFullChildren', 'children$', children)
          this.$set(data$, 'children', children)
          return data$
        }
      } catch (err) {
        console.error('CATCH', 'LOGICAL_TREE', 'LOAD FULL CHILDREN', err)
      }
      return undefined
    },

    onItemSelect(item: TreeNode): void {
      this.$emit('select', item)
    },

    checkType(item: TreeNode): boolean {
      let checked: boolean
      
      if (this.portType) {
        checked = item.port_type === this.portType || item.id === this.portType
      } else {
        const types = this.loadTemplatePort()
        if (Array.isArray(types)) {
          checked = types.includes(item.port_type)
        } else {
          checked = item.port_type === types
        }
      }
      return checked
    },

    checkBusy(item: TreeNode): boolean {
      let busy = false
      if (item.brefs?.length && item.brefs.some(bref => bref.cls === 'connection')) {
        busy = true
      }
      return busy
    },

    loadTemplatePort(): string | string[] | undefined {
      let portType: string | string[] | undefined
      
      if (this.template) {
        const template$ = this.templates.find(item => {
          return item.id === this.template || item.port_type === this.template
        })
        portType = template$ ? template$.port_type : 'no ports'
      }
      return portType
    },

    getClass(status: string): string {
      if (this.$store.state.books.statuses.length) {
        let color = this.$store.state.books.statuses.find((item: StatusColor) => {
          return item.name === status
        })
        if (!color) {
          color = this.$store.state.books.statuses.find((item: StatusColor) => {
            return item.name === 'unknown'
          })
        }
        return color?.back_color || 'grey'
      }
      return 'grey'
    },
  },
})
</script>

<style lang="css" scoped>
</style>
